<div class="card" style=" margin: 0; padding: 0; border-top: 0px !important;">
       <p-card class="pt-0">
        <app-schedulelogfilters></app-schedulelogfilters>
      </p-card>
        <div class="mr-0">
          <p-table #dt [value]="tableData" [rows]="rows2" [scrollable]="true" scrollDirection="horizontal"
          scrollHeight="400px" [globalFilterFields]="['createdon','schedulerid','productname','schedulerclassname','schedulermethodname','schedulername','schedulertype','status']" 
          [resizableColumns]="true" columnResizeMode="expand" [customSort]="true" [first]="currentPageIndex"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" 
          [rowsPerPageOptions]=paginatorArray dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
          paginatorLocale="fa-IR" [paginator]="totalRecords>0" responsiveLayout="scroll" (onPage)="handlePageChange($event)"
          [lazy]="true" (onLazyLoad)="getData($event)" [totalRecords]="totalRecords" sortField="createdon" [sortOrder]="-1" >
          <ng-template pTemplate="caption">
          <div class="table-header ">
            <div class="grid">
              <!-- <div class="col-12 lg:col-3 md:col-3 sm:col-12">
                <div class="grid">
                  <div class="col-6 lg:col-6 md:col-6 sm:col-12" style="display: flex;">
                  </div>
                </div>
              </div> -->
              <div class="col-12 md:col-10 sm:col-12 lg:col-10">
                <span class=" p-input-icon-lft">
                  <i icon="pi pi-search"></i>
                  <input class="form-control" pInputText type="text" id="tablesearch"
                    (input)="dt.filterGlobal($any($event.target).value , 'contains')"
                    placeholder="Search in Scheduler Log" class="tablesearch" pTooltip="Enter Search Criteria"
                    tooltipPosition="top" />
                </span>
              </div>
              <div class="col-12 sm:col-2 md:col-2 sm:col-12 ">
                <div class="iconexcel" pTooltip="Download Data"
                tooltipPosition="bottom" style="cursor: pointer;" (click)="schedularlogModal=true" ></div>
              </div>
            </div>
          </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
                <ng-container *ngFor="let col of _selectedColumns">
            <th pResizableColumn [pSortableColumn]="col.field" *ngIf="col.isChecked " [style.width]="col.width"
              [class]="col.class">{{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
                </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data>
          <tr [ngStyle]="{'background-color': data.status == 'N' ? '#FFE6E6':'transparent'}">
              <ng-container *ngFor="let col of _selectedColumns" >
                <td *ngIf="col.isChecked" [style.width]="col.width" [style.align]="col.width" [class]="col.class">
                 <!-- <span  pTooltip=" {{data[col.field]}}">{{data[col.field]}}</span> -->
                         <span *ngIf="(col.field!=='status')" pTooltip=" {{data[col.field] }}">{{data[col.field]}}</span>
                 <span *ngIf="col.field=='status'">
                  <span *ngIf="data[col.field]=== 'Y' " pTooltip="Success" tooltipPosition="left" >Success</span>
                  <span *ngIf="data[col.field]=== 'N' " pTooltip="Failed" tooltipPosition="left">Failed</span>
                   </span>  
               </td>
             </ng-container>
            </tr>
          </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="datanotfound">
            No data available
          </td>
        </tr>
      </ng-template>
        </p-table>
      </div>
</div>
<p-dialog header="Excel Download" [(visible)]="exceldownloadModal" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000"
    [draggable]="true" [resizable]="false" position="top">
    <div class="dialog-content-min-excel" style=" text-align: center !important;">
      <div class="card">
        <p>{{excel_paragraph}}</p>
      </div>
    </div>
       <div class="custom-dialog-footer">
        <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="schedularlogModal=false" ></p-button>
        <p-button class="m-1 w-full"   label="Download" styleClass="customesave"></p-button>
     </div>
</p-dialog>

<p-dialog header="Excel Download" [(visible)]="schedularlogModal" [modal]="true" [style]="{height:'12vw', width: '44vw'}" [baseZIndex]="10000"
    [draggable]="true" [resizable]="false" position="center">
    <div class="dialog-content-min-excel" style=" text-align: center !important;">
      <div class="card">
        <p>{{excel_paragraph}}</p>
      </div>
    </div>
       <div class="custom-dialog-footer">
        <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="schedularlogModal=false" ></p-button>
        <p-button class="m-1 w-full"   label="Download" styleClass="customesave" (click)="schedularlogDataExcel()" ></p-button>
     </div>
</p-dialog>

<p-dialog header="Excel Download" [(visible)]="taskfullbackupModal" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000"
    [draggable]="true" [resizable]="false" position="top">
    <div class="modal-dialog modal-lg" style="width:100% !important;">
      <div class="modal-content">
      <form name="taskfullbackupform" id="taskfullbackupform" method="post">
      <div class="modal-header">
        <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="taskfullbackupModal=false" ></p-button>
        <h4 class="modal-title "  style="text-align:center;">Generate Full Backup of Task System</h4>
      </div>
      <div class="modal-body">
      <div class="row">
      <div class="col-lg-12">
      <p style="font-size:1.3rem;font-weight:bolder;">
      This function will generate the complete Backup of the Task System.<br/>
      An Excel file with different tabs containing Master and Transaction information will be generated and placed in the Download directory
      </p></div></div></div>
      <div class="modal-footer">
        <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="taskfullbackupModal=false" ></p-button>
        <p-button class="m-1 w-full"   label="Download" styleClass="customesave" ></p-button>
     </div></form></div></div>
</p-dialog>


